export default (sitemap: SitemapBuilder) =>
{
    const runtimeConfig = useRuntimeConfig();

    sitemap.after('[[[Marketing]]]', [
        {
            name: '[[[Sklep]]]',
            short: '[[[Sklep]]]',
            icon: 'shopping-cart',
            children: [
                {
                    name: '[[[Sprzedaż]]]',
                    header: true
                },
                {
                    name: '[[[Zamówienia]]]',
                    icon: 'receipt',
                    route: 'store-orders',
                    namespace: 'Ideo.Core.ECommerce.Application.Cases.Sales.Orders.Permissions',
                    auth: { all: ['OrdersPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Szczegóły zamówienia]]]',
                            route: 'store-orders-edit',
                            auth: { all: ['OrdersPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Klienci]]]',
                    icon: 'users',
                    route: 'store-clients',
                    namespace: 'Ideo.Core.ECommerce.Application.Cases.Sales.Orders.Permissions',
                    auth: { all: ['OrdersPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Szczegóły klienta]]]',
                            route: 'store-clients-details',
                            auth: { all: ['OrdersPermissions@View'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Faktury]]]',
                    icon: 'file-text',
                    route: 'store-invoices',
                    namespace: 'Ideo.Core.ECommerce.Application.Cases.Sales.Orders.Permissions',
                    auth: { all: ['OrdersPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie faktury]]]',
                            route: 'store-invoices-add',
                            auth: { all: ['OrdersPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Szczegóły faktury]]]',
                            route: 'store-invoices-edit',
                            auth: { all: ['OrdersPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Reklamacje]]]',
                    icon: 'triangle-alert',
                    route: 'store-complaints',
                    namespace: 'Ideo.Core.ECommerce.Application.Cases.Sales.Complaints.Permissions',
                    auth: { all: ['ComplaintsPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Szczegóły zgłoszenia]]]',
                            route: 'store-complaints-edit',
                            auth: { all: ['ComplaintsPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Zwroty]]]',
                    icon: 'rotate-ccw',
                    route: 'store-returns',
                    namespace: 'Ideo.Core.ECommerce.Application.Cases.Sales.Returns.Permissions',
                    auth: { all: ['ReturnsPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Szczegóły zwrotu]]]',
                            route: 'store-returns-edit',
                            auth: { all: ['ReturnsPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Opinie produktowe]]]',
                    icon: 'messages-square',
                    route: 'store-ratings',
                    namespace: 'Ideo.Core.ECommerce.Application.Cases.Sales.Ratings.Permissions',
                    auth: { all: ['RatingsPremissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Szczegóły opinii]]]',
                            route: 'store-ratings-edit',
                            auth: { all: ['RatingsPremissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Cenniki]]]',
                    route: 'store-price-lists',
                    icon: 'table-properties',
                    namespace: 'Ideo.Core.ECommerce.Application.Cases.Settings.PriceLists.Permissions',
                    auth: { all: ['PriceListsPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie cennika]]]',
                            route: 'store-price-lists-add',
                            auth: { all: ['PriceListsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja cennika]]]',
                            route: 'store-price-lists-edit',
                            auth: { all: ['PriceListsPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Promocje]]]',
                    icon: 'badge-percent',
                    children: [
                        {
                            name: '[[[Kody rabatowe]]]',
                            route: 'store-promotion-codes',
                            namespace: 'Ideo.Core.ECommerce.Application.Cases.Sales.Promotions.Permissions',
                            auth: { all: ['PromotionsPermissions@View'], any: [] },
                            children: [
                                {
                                    name: '[[[Dodanie promocji kodów rabatowych]]]',
                                    route: 'store-promotion-codes-add',
                                    auth: { all: ['PromotionsPermissions@Edit'], any: [] },
                                    visible: false
                                },
                                {
                                    name: '[[[Edycja promocji kodów rabatowych]]]',
                                    route: 'store-promotion-codes-edit',
                                    auth: { all: ['PromotionsPermissions@Edit'], any: [] },
                                    visible: false
                                }
                            ]
                        },
                        {
                            name: '[[[Przeceny produktów]]]',
                            route: 'store-promotion-discounts',
                            namespace: 'Ideo.Core.ECommerce.Application.Cases.Sales.Promotions.Permissions',
                            auth: { all: ['PromotionsPermissions@View'], any: [] },
                            children: [
                                {
                                    name: '[[[Dodanie przeceny produktów]]]',
                                    route: 'store-promotion-discounts-add',
                                    auth: { all: ['PromotionsPermissions@Edit'], any: [] },
                                    visible: false
                                },
                                {
                                    name: '[[[Edycja przeceny produktów]]]',
                                    route: 'store-promotion-discounts-edit',
                                    auth: { all: ['PromotionsPermissions@Edit'], any: [] },
                                    visible: false
                                }
                            ]
                        },
                        {
                            name: '[[[Promocje wiązana]]]',
                            route: 'store-promotion-bundles',
                            namespace: 'Ideo.Core.ECommerce.Application.Cases.Sales.Promotions.Permissions',
                            auth: { all: ['PromotionsPermissions@View'], any: [] },
                            children: [
                                {
                                    name: '[[[Dodanie promocji wiązanej]]]',
                                    route: 'store-promotion-bundles-add',
                                    auth: { all: ['PromotionsPermissions@Edit'], any: [] },
                                    visible: false
                                },
                                {
                                    name: '[[[Edycja promocji wiązanej]]]',
                                    route: 'store-promotion-bundles-edit',
                                    auth: { all: ['PromotionsPermissions@Edit'], any: [] },
                                    visible: false
                                }
                            ]
                        },
                    ]
                },
                {
                    name: '[[[Katalog]]]',
                    header: true
                },
                {
                    name: '[[[Produkty]]]',
                    route: 'store-products',
                    icon: 'package',
                    namespace: 'Ideo.Core.ECommerce.Application.Cases.Catalog.Products.Permissions',
                    auth: { all: ['ProductsPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie produktu]]]',
                            route: 'store-products-add',
                            auth: { all: ['ProductsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja produktu]]]',
                            route: 'store-products-edit',
                            auth: { all: ['ProductsPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Szablony kart produktów]]]',
                    route: 'store-product-builder-templates',
                    visible: runtimeConfig.public.productBuilderEnabled,
                    icon: 'layout-template',
                    namespace: 'Ideo.Core.ECommerce.Application.Cases.Catalog.Products.Permissions',
                    auth: { all: ['ProductsPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Nowy szablon karty]]]',
                            route: 'store-product-builder-templates-add',
                            auth: { all: ['ProductsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja szablonu karty]]]',
                            route: 'store-product-builder-templates-edit',
                            auth: { all: ['ProductsPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Kategorie]]]',
                    route: 'store-categories',
                    icon: 'folder-tree',
                    namespace: 'Ideo.Core.ECommerce.Application.Cases.Catalog.Categories.Permissions',
                    auth: { all: ['CategoriesPermissions@View'], any: [] }
                },
                {
                    name: '[[[Kolekcje]]]',
                    route: 'store-collections',
                    icon: 'library-big',
                    namespace: 'Ideo.Core.ECommerce.Application.Cases.Catalog.Collections.Permissions',
                    auth: { all: ['CollectionsPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie kolekcji]]]',
                            route: 'store-collections-add',
                            auth: { all: ['CollectionsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja kolekcji]]]',
                            route: 'store-collections-edit',
                            auth: { all: ['CollectionsPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Producenci]]]',
                    route: 'store-producers',
                    namespace: 'Ideo.Core.ECommerce.Application.Cases.Catalog.Producers.Permissions',
                    icon: 'factory',
                    auth: { all: ['ProducersPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie producenta]]]',
                            route: 'store-producers-add',
                            auth: { all: ['ProducersPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja producenta]]]',
                            route: 'store-producers-edit',
                            auth: { all: ['ProducersPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Etykiety]]]',
                    route: 'store-labels',
                    icon: 'tags',
                    namespace: 'Ideo.Core.ECommerce.Application.Cases.Catalog.Labels.Permissions',
                    auth: { all: ['LabelsPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie etykiety]]]',
                            route: 'store-labels-add',
                            auth: { all: ['LabelsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja etykiety]]]',
                            route: 'store-labels-edit',
                            auth: { all: ['LabelsPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Grupy cech]]]',
                    route: 'store-properties-groups',
                    icon: 'folder-kanban',
                    namespace: 'Ideo.Core.ECommerce.Application.Cases.Catalog.PropertiesGroups.Permissions',
                    auth: { all: ['PropertiesGroupsPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie grupy cech]]]',
                            route: 'store-properties-groups-add',
                            auth: { all: ['PropertiesGroupsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja grupy cech]]]',
                            route: 'store-properties-groups-edit',
                            auth: { all: ['PropertiesGroupsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Sortowanie grup cech]]]',
                            route: 'store-properties-groups-sort',
                            auth: { all: ['PropertiesGroupsPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Cechy]]]',
                    route: 'store-properties',
                    icon: 'layout-grid',
                    namespace: 'Ideo.Core.ECommerce.Application.Cases.Catalog.Properties.Permissions',
                    auth: { all: ['PropertiesPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie cechy]]]',
                            route: 'store-properties-add',
                            auth: { all: ['PropertiesPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja cechy]]]',
                            route: 'store-properties-edit',
                            auth: { all: ['PropertiesPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Sortowanie cech]]]',
                            route: 'store-properties-sort',
                            auth: { all: ['PropertiesPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Sortowanie wartości]]]',
                            route: 'store-properties-values-sort',
                            auth: { all: ['PropertiesPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Konfiguracja]]]',
                    header: true
                },
                {
                    name: '[[[Sklepy]]]',
                    route: 'store-shops',
                    icon: 'store',
                    namespace: 'Ideo.Core.ECommerce.Application.Cases.Settings.Shops.Permissions',
                    auth: { all: ['ShopsPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie sklepów]]]',
                            route: 'store-shops-add',
                            auth: { all: ['ShopsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja sklepów]]]',
                            route: 'store-shops-edit',
                            auth: { all: ['ShopsPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Waluty]]]',
                    route: 'store-currencies',
                    icon: 'coins',
                    namespace: 'Ideo.Core.ECommerce.Application.Cases.Settings.Currencies.Permissions',
                    auth: { all: ['CurrenciesPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie waluty]]]',
                            route: 'store-currencies-add',
                            auth: { all: ['CurrenciesPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja waluty]]]',
                            route: 'store-currencies-edit',
                            auth: { all: ['CurrenciesPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Podatki]]]',
                    route: 'store-taxations',
                    icon: 'wallet-cards',
                    namespace: 'Ideo.Core.ECommerce.Application.Cases.Settings.Taxations.Permissions',
                    auth: { all: ['TaxationsPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie stawki]]]',
                            route: 'store-taxations-add',
                            auth: { all: ['TaxationsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja stawki]]]',
                            route: 'store-taxations-edit',
                            auth: { all: ['TaxationsPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Grupy klientów]]]',
                    route: 'store-customer-groups',
                    icon: 'users-round',
                    namespace: 'Ideo.Core.ECommerce.Application.Cases.Settings.CustomerGroups.Permissions',
                    auth: { all: ['CustomerGroupsPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie grupy klientów]]]',
                            route: 'store-customer-groups-add',
                            auth: { all: ['CustomerGroupsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja grupy klientów]]]',
                            route: 'store-customer-groups-edit',
                            auth: { all: ['CustomerGroupsPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Kraje]]]',
                    route: 'store-countries',
                    icon: 'flag',
                    namespace: 'Ideo.Core.ECommerce.Application.Cases.Settings.Countries.Permissions',
                    auth: { all: ['CountriesPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie kraju]]]',
                            route: 'store-countries-add',
                            auth: { all: ['CountriesPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja kraju]]]',
                            route: 'store-countries-edit',
                            auth: { all: ['CountriesPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Dostawy]]]',
                    route: 'store-deliveries',
                    icon: 'truck',
                    namespace: 'Ideo.Core.ECommerce.Application.Cases.Settings.Deliveries.Permissions',
                    auth: { all: ['DeliveriesPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie opcji dostawy]]]',
                            route: 'store-deliveries-add',
                            auth: { all: ['DeliveriesPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja opcji dostawy]]]',
                            route: 'store-deliveries-edit',
                            auth: { all: ['DeliveriesPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Płatności]]]',
                    route: 'store-payments',
                    icon: 'credit-card',
                    namespace: 'Ideo.Core.ECommerce.Application.Cases.Settings.Payments.Permissions',
                    auth: { all: ['PaymentsPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie opcji płatności]]]',
                            route: 'store-payments-add',
                            auth: { all: ['PaymentsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja opcji płatności]]]',
                            route: 'store-payments-edit',
                            auth: { all: ['PaymentsPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Kalendarz]]]',
                    route: 'store-calendar-entries',
                    icon: 'calendar',
                    namespace: 'Ideo.Core.ECommerce.Application.Cases.Settings.CalendarEntries.Permissions',
                    auth: { all: ['CalendarEntriesPermisions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie wpisu do kalendarza]]]',
                            route: 'store-calendar-entries-add',
                            auth: { all: ['CalendarEntriesPermisions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja wpisu do kalendarza]]]',
                            route: 'store-calendar-entries-edit',
                            auth: { all: ['CalendarEntriesPermisions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Parametry UTM]]]',
                    route: 'store-utm-parameters',
                    icon: 'link',
                    namespace: 'Ideo.Core.ECommerce.Application.Cases.Settings.UtmParameters.Permissions',
                    auth: { all: ['UtmParametersPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie parametru UTM]]]',
                            route: 'store-utm-parameters-add',
                            auth: { all: ['UtmParametersPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja parametru UTM]]]',
                            route: 'store-utm-parameters-edit',
                            auth: { all: ['UtmParametersPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Powiadomienia]]]',
                    route: 'store-notifications',
                    icon: 'bell',
                    namespace: 'Ideo.Core.ECommerce.Application.Cases.Settings.Notifications.Permissions',
                    auth: { all: ['NotificationsPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie powiadomienia]]]',
                            route: 'store-notifications-add',
                            auth: { all: ['NotificationsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja powiadomienia]]]',
                            route: 'store-notifications-edit',
                            auth: { all: ['NotificationsPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Reklamacje]]]',
                    route: 'store-complaints-settings',
                    icon: 'rotate-ccw',
                    namespace: 'Ideo.Core.ECommerce.Application.Cases.Sales.Complaints.Permissions',
                    auth: { all: ['ComplaintsPermissions@Edit'], any: [] }
                },
                {
                    name: '[[[Opinie]]]',
                    route: 'store-ratings-settings',
                    icon: 'messages-square',
                    namespace: 'Ideo.Core.ECommerce.Application.Cases.Sales.Ratings.Permissions',
                    auth: { all: ['RatingsPremissions@View'], any: [] }
                },
                {
                    name: '[[[Koszyki]]]',
                    route: 'store-shopping-carts-settings',
                    icon: 'shopping-cart',
                    namespace: 'Ideo.Core.ECommerce.Application.Cases.Settings.ShoppingCarts.Permissions',
                    auth: { all: ['ShoppingCartsPremissions@View'], any: [] }
                },
                {
                    name: '[[[InPost Pay]]]',
                    route: 'store-inpost-pay-settings',
                    icon: 'package',
                    namespace: 'Ideo.Core.Integrations.InPostPay.Cases.Settings.Permissions',
                    auth: { all: ['InPostPaySettingsPermissions@View'], any: [] }
                },
                {
                    name: '[[[Eksporty]]]',
                    route: 'store-exports',
                    icon: 'file-output',
                    namespace: 'Ideo.Core.ECommerce.Application.Cases.Settings.Exports.Permissions',
                    auth: { all: ['ExportsPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie eksportu]]]',
                            route: 'store-exports-add',
                            auth: { all: ['ExportsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja eksportu]]]',
                            route: 'store-exports-edit',
                            auth: { all: ['ExportsPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                }
            ]
        }
    ]);
};
